function ctaLegacyModes(value) {
  let updatedValue = value;

  // AO Smith added 'MODE_' before their mode values for some reason (e.g. mode: 'MODE_RUN_NORMAL')
  if (value.startsWith('MODE_')) {
    updatedValue = value.substring('MODE_'.length);
  }

  // Originally the CTA mode listed 'RUN_NORMAL'. We now prefer 'NORMAL' which also
  // capture 'IDLE_NORMAL' cta op state
  if (updatedValue === 'RUN_NORMAL') {
    updatedValue = 'NORMAL';
  }
  return updatedValue;
};

function humanReadableCommandMode(rawCommandMode) {
  // Example: 'DUTY_CYCLE' -> 'Duty Cycle'
  return (new String(rawCommandMode))
    .toLowerCase()
    .split('_')
    .map(word => (word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ');
}

module.exports = {
  ctaLegacyModes,
  humanReadableCommandMode,
};